import { useSearchParams } from "@pankod/refine-react-router-v6";
import { CONST } from "config/const";

export const useLayoutOffFlag = () => {
  const [searchParams] = useSearchParams();
  const isPreviewVRM = !!searchParams.get(CONST.PARAMS.PREVIEW_VRM);
  const isLayoutOff = isPreviewVRM;

  return isLayoutOff;
};
